/* eslint-disable */
import React, { useEffect } from "react";
import { getRentPayments } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const RentPayments = ({ getRentPayments, rentPayments, period }) => {
  // Initial load
  useEffect(() => {
    getRentPayments({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getRentPayments(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = {
      page,
      limit: 20
    };
    
    if (!period?.startDate && !period?.endDate) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate) {
      payload.startDate = period?.startDate || "";
      payload.endDate = period?.endDate || "";
    }
    
    getRentPayments(payload);
  };

  return (
    <DataTable
      {...tablePresets.rentPayments}
      data={rentPayments}
      fetchData={getRentPayments}
      period={period}
      onLoadMore={handleLoadMore}
    />
  );
};

const mapStateToProps = (state) => ({
  rentPayments: state.appProperties.rentPayments,
});

const mapDispatchToProps = (dispatch) => ({
  getRentPayments: (payload) => dispatch(getRentPayments(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RentPayments);